// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { LayoutState, PreviewPanelState } from '../../../../common/types.tsx';

export const setPreviewPanelState =
	(newState: Partial<PreviewPanelState>): Action<LayoutState> =>
	({ getState, setState }) => {
		const { content } = getState();
		setState({
			content: {
				...content,
				previewPanel: {
					...content.previewPanel,
					...newState,
				},
			},
		});
	};
